import { render, staticRenderFns } from "./WalletTransferReceipts.vue?vue&type=template&id=bbb421a2&"
import script from "./WalletTransferReceipts.vue?vue&type=script&lang=js&"
export * from "./WalletTransferReceipts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports